/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `in_processing` - In Processing
 */
export enum OrderEditStatusEnum {
  DATA_ENTRY = 'data_entry',
  INSPECTION = 'inspection',
  OFFER_READY = 'offer_ready',
  IN_PROCESSING = 'in_processing',
}
